/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/tadris-request',
  name: 'tadrisRequest',
  component: () => import('@/views/tadris/Request'),
},
// {
//   path: '/tadris-history',
//   name: 'tadrisHistory',
//   component: () => import('@/views/tadris/Index'),
// }
]

